// More like this (the brief, "Sections"): games of the same kind, ranked by what they share with this one (genre,
// themes, mood), with Halloween-row games first while Open Haunt runs on a Halloween-row game's page. Playable now
// only; real art before typographic covers before none. Pure.

import { isComingSoon, type Catalogue, type Game } from "../../catalogue.ts";
import { typedCover } from "../../components.ts";
import { coverUrl } from "../../rows.ts";

const shared = (a: readonly string[] | undefined, b: readonly string[] | undefined) => (a && b ? a.filter((x) => b.includes(x)).length : 0);

/** How alike two games are: 0 means not alike at all. */
export function likeness(g: Game, x: Game): number {
  return (x.genre === g.genre ? 3 : 0) + 2 * shared(g.themes, x.themes) + shared(g.mood, x.mood);
}

const artRank = (x: Game) => (!coverUrl(x) ? 2 : typedCover(x) ? 1 : 0);

/**
 * Up to `n` games like `g`. `boost`: ids to lead with (the Halloween row while it runs), used only when `g` is one of
 * them.
 */
export function similarGames(cat: Pick<Catalogue, "games">, g: Game, n = 10, boost: ReadonlySet<string> = new Set()): Game[] {
  const lead = boost.has(g.id);
  return cat.games
    .filter((x) => x.id !== g.id && x.kind === g.kind && !isComingSoon(x))
    .map((x, i) => ({ x, i, s: likeness(g, x) + (lead && boost.has(x.id) ? 5 : 0) }))
    .filter((r) => r.s > 0)
    .sort((a, b) => b.s - a.s || artRank(a.x) - artRank(b.x) || a.i - b.i)
    .slice(0, n)
    .map((r) => r.x);
}
